<template>
  <div class="year-apply">
    <div class="year-apply.header">
      <!-- <el-button
            type="primary"
            class="exportOut"
            icon="el-icon-download"
            @click="exportOut"
      >导出</el-button>-->
      <el-popover placement="bottom" width="300" v-model="visible">
        <el-date-picker
          style="width:100%"
          v-model="times"
          type="daterange"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
        <div style="text-align: right; margin-top: 10px">
          <el-button size="mini" type="text" @click="()=>{visible = false;times = null}">取消</el-button>
          <el-button type="primary" size="mini" @click="exportOut">确定</el-button>
        </div>
        <el-button
          class="exportOut"
          style="margin-left:10px;"
          slot="reference"
          type="primary"
          icon="el-icon-download"
        >导出</el-button>
      </el-popover>
      <el-input
        placeholder="请输入内容"
        v-model="searchValue"
        class="input-with-select"
        @keyup.enter.native="search"
        clearable
        @clear="search"
      >
        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
      </el-input>
      <label style="margin-right:10px;line-height:40px;min-width:60px;">审核状态:</label>
      <el-select v-model="statusVal" placeholder="请选择" @change="search">
        <el-option label="全部" value></el-option>
        <el-option label="初审通过" :value="1"></el-option>
        <el-option label="初审未通过" :value="2"></el-option>
        <el-option label="待初审" :value="3"></el-option>
        <el-option label="已完结" :value="4"></el-option>
        <el-option label="复审未通过" :value="5"></el-option>
        <el-option label="复审已通过" :value="6"></el-option>
      </el-select>
    </div>
    <Table :table="table" :url="url" @editEvent="editEvent" ref="children"></Table>
    <el-dialog
      title="年检技术贸易资格"
      :visible.sync="dialogFormVisible"
      :show-close="false"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
    >
      <el-form :model="form" ref="form" label-width="80px">
        <el-row :gutter="100">
          <el-col :span="12">
            <el-form-item label="单位名称">
              <el-input v-model="form.unit" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单位地址">
              <el-input v-model="form.address" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="100">
          <el-col :span="12">
            <el-form-item label="联系人">
              <el-input v-model="form.contact" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式">
              <el-input v-model="form.phone" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="短信通知">
              <el-radio-group
                v-model="form.is_phone"
                style="width: 100%;text-align: left;"
                disabled
              >
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item
              label="技术贸易资格证书副本"
              prop="tech_trade_cert_lic_src"
              style="text-align: left;"
              class="file-class"
              label-width="160px"
            >
              <a
                style="margin-right:10px"
                :href="item.url"
                target="_blank"
                v-for="(item,index) in form.tech_trade_cert_lic_src"
                :key="index"
              >{{item.name}}</a>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="甘肃省技术贸易资格证书年检登记表"
              prop="prov_tech_trade_cert_ver_src"
              style="text-align: left;"
              label-width="240px"
              class="file-class"
            >
              <a
                style="margin-right:10px"
                :href="item.url"
                target="_blank"
                v-for="(item,index) in form.prov_tech_trade_cert_ver_src"
                :key="index"
              >{{item.name}}</a>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px;">
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input
                type="textarea"
                :autosize="{ minRows: 6, maxRows: 6 }"
                v-model="form.remark"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="审核" prop="status" style="width:100%">
              <el-select style="width:100%" v-model="form.status" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                  :disabled="item.disabled"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="补正意见" prop="suggest">
          <el-input
            type="textarea"
            :autosize="{ minRows: 6, maxRows: 6 }"
            placeholder="请输入内容..."
            v-model="form.suggest"
          ></el-input>
        </el-form-item>
        <el-form-item style="text-align:right">
          <el-button @click="close('form')">取消</el-button>
          <el-button type="primary" @click="submit('form')">确认</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Table from "./table.vue";
export default {
  components: {
    Table,
  },
  data() {
    return {
      visible: false,
      times: "",
      table: {
        columns: [
          { prop: "contact", label: "联系人" },
          { prop: "phone", label: "预约电话" },
          { prop: "dateTime", label: "申请时间" },
          { prop: "status", label: "审核状态", type: "status", moreText: true },
          { prop: "remark", label: "备注" },
        ],
        hasBtn: true,
        hasSelect: false,
        btns: [{ name: "编辑", event: "editEvent", type: "success" }],
      },
      url: "Technology_Skill?type=2",
      searchValue: "",
      statusVal: "",
      dialogFormVisible: false,
      options: [
        {
          id: 3,
          name: "待初审",
          disabled: true,
        },
        {
          id: 1,
          name: "初审通过",
        },
        {
          id: 2,
          name: "初审未通过",
        },
        {
          id: 4,
          name: "已完结",
          disabled: true,
        },
        {
          id: 5,
          name: "复审未通过",
        },
        {
          id: 6,
          name: "复审已通过",
        },
      ],
      form: {
        unit: "",
        address: "",
        contact: "",
        phone: "",
        is_phone: 1,
        tech_trade_cert_lic_src: [], //技术贸易
        prov_tech_trade_cert_ver_src: [], //年检登记表
        remark: "",
        status: "",
        suggest: "",
        id: "",
      },
    };
  },
  methods: {
    //导出
    exportOut() {
      let url = "";
      if (this.times) {
      /*url =
        window.urlConfig.url +
        "Technology_Skill_Export?type=2&time_type=1&start_datetime=" +
        this.times[0] +
        "&end_datetime=" +
        this.times[1];*/
        url = `${urlConfig.devUrl}apij2/admin-api/signature/technology-skill/export-excel?type=2&time_type=1&date=`+this.times
      } else {
        // url = window.urlConfig.url + "Technology_Skill_Export?type=2";
        url = `${urlConfig.devUrl}apij2/admin-api/signature/technology-skill/export-excel?type=2`
      }
      var a = document.createElement("a");
      a.href = url;
      a.download = "";
      a.click();
      this.visible = false;
      this.times = null;
    },
    search() {
      this.url = `/Technology_Skill?type=2&contact=${this.searchValue}&status=${this.statusVal}`;
    },
    editEvent(row) {
      // console.log(row)
      this.dialogFormVisible = true;
      this.form.unit = row.unit;
      this.form.address = row.address;
      this.form.contact = row.contact;
      this.form.phone = row.phone;
      this.form.tech_trade_cert_lic_src = this.formatFile(
        row.techTradeCertLicSrc
      );
      this.form.prov_tech_trade_cert_ver_src = this.formatFile(
        row.provTechTradeCertVerSrc
      );
      this.form.remark = row.remark;
      this.form.suggest = row.suggest;
      this.form.status = row.status;
      this.form.id = row.id;
      this.form.user_id = row.userId;
    },
    close(formName) {
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false;
    },
    formatFile(files) {
      let arrs = [];
      files &&
        files.split(",").forEach((item, index) => {
          arrs.push({
            name: "材料-" + (index + 1),
            url: item,
          });
        });
      return arrs;
    },
    // 发送短信验证码
    sendMessage(content, phone) {
      this.http
        .post("code/common_send", {
          content: content,
          phone: phone,
        })
        .then((res) => {});
    },
    submit(formName) {
      let tip = "";
      let obj = {};
      this.$refs[formName].validate((valid) => {
        if (valid) {
          obj.status = this.form.status;
          obj.type = 2;
          if (obj.status == 1) {
            tip =
              "恭喜您预约的办理技术贸易资格证(年检)审核通过，请登录平台查看详情。";
          }
          if (obj.status == 2) {
            tip =
              "很遗憾的通知到您，您提交的办理技术贸易资格证(年检)未审核通过，请登录平台查看详情。";
          }
          obj.suggest = this.form.suggest;
          obj.user_id = this.form.user_id;
          obj.userId = obj.user_id;
          obj.id = this.form.id;
          this.http.post(`${urlConfig.devUrl}apij2/admin-api/signature/technology-skill/update`, obj).then((res) => {
            if (res.code == 0) {
              this.$message.success("审核成功");
              if (obj.status != 3) {
                if (tip) {
                  this.sendMessage(tip, this.form.phone);
                }
              }
              this.dialogFormVisible = false;
              this.$refs.children.getData(this.url);
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
@include component(year-apply) {
  @include part(header) {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    margin-bottom: 20px;
    .el-input {
      width: 400px;
      margin: 0 15px;
    }
  }
  .file-class {
    .el-form-item__content {
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
